import { LocationInformation } from "types/locationInformation";

export function locationInformationPayload(locationInformation: LocationInformation) {
  const { certificateOfInsuranceFile, ...fields } = locationInformation;

  if (typeof certificateOfInsuranceFile === "string" && certificateOfInsuranceFile.length > 0) {
    return { ...fields, certificateOfInsuranceFile };
  }

  return fields;
}
